import { render } from "./MyNotice.vue?vue&type=template&id=792f2063"
import script from "./MyNotice.vue?vue&type=script&lang=js"
export * from "./MyNotice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__